import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getEmployees, getInActiveEmployees } from '../../actions/userActions/employeeAction';
import './Employee.css';
import Loader from '../subComponents/Loader';
import { Link, useHistory } from 'react-router-dom';
import Pagination from '../paginatioin/pagination';
import { Tooltip } from "@mui/material";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import IconButton from '@mui/material/IconButton';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from '../../actions/types';
import HeaderComponent from '../reuse_components/HeaderComponent';
import { downloadEmployee } from '../../actions/userActions/downloadEmployeeAction';
import DynamicTable from '../reuse_components/DynamicTable';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import SearchInput from '../subComponents/search/SearchInput';
import Heading6Regular from '../designSystem/Heading6Regular';
import CustomPagination from '../subComponents/pagination/CustomPagination';
import CustomButton from '../subComponents/buttons/CustomButton';

import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import { Download } from 'lucide-react';
import FilterSelect from '../designSystem/FilterSelect';
import CustomFilterSelect from '../designSystem/CustomFilterSelect';


function Employees() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [query, setQuery] = useState('');
  const [previousQuery, setPreviousQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [permission, setPermission] = useState(false);
  const [statusFilter, setStatusFilter] = useState(2);
  const itemsPerPage = 10;
  useEffect(() => {
    const pageNumber = currentPage;
    if (query !== previousQuery) {
      setCurrentPage(1);
    }  
    if (statusFilter === 1) {
      dispatch(getEmployees(pageNumber, SIZE_OF_PAGE, query));
    } else if (statusFilter === 2) {
      dispatch(getEmployees(pageNumber, SIZE_OF_PAGE, query, true)); 
    } else if (statusFilter === 3) {
      dispatch(getInActiveEmployees(pageNumber, SIZE_OF_PAGE, query));
    }
  
    setPreviousQuery(query);
    setButtonPermission();
  }, [currentPage, query, statusFilter]);
  
  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter]);
  
  const employees = useSelector((state) => state.employees_reducer.employees);
  const inActiveEmployees = useSelector((state) => state.employees_reducer.InActivEemployees);
  const permissions = JSON.parse(localStorage.getItem('permissionsList'));
  const getTotalPaginationInfo = () => {
    if (statusFilter === 3) {
      return {
        totalCount: inActiveEmployees?.totalCount || 0,
        totalPages: inActiveEmployees?.totalPages || 0,
      };
    }
  
    // Case 2: Active - now handled via backend, no filtering needed
    if (statusFilter === 2) {
      return {
        totalCount: employees?.totalCount || 0,
        totalPages: employees?.totalPages || 0,
      };
    }
  
    // Case 1: All employees
    return {
      totalCount: employees?.totalCount || 0,
      totalPages: employees?.totalPages || 0,
    };
  };
  
  const { totalCount, totalPages } = getTotalPaginationInfo();
  const handleSearchChange = (query) => {
    setQuery(query);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    history.push(`?page=${page}&search=${query}`);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setCurrentPage(1);
  };

  const handleAddEmployeeClick = () => {
    history.push('/admin/Addemployees');
  };
  const setButtonPermission = () => {
    if (permissions.includes('CanAddEmployee')) {
      setPermission(true);
    }
  }
  const handleEmployeeDownload = () => {
    dispatch(downloadEmployee());
  };
  const EmployeeData = (() => {
    const inActiveData = inActiveEmployees.result || []
    if (statusFilter === 3) {
      return inActiveData?.map((employee) => ({
        ...employee,
        empId: employee.empId || "N/A",
        fullName: `${employee.firstName} ${employee.lastName}`,
        status: "Inactive",
        lastLogin: formatDate(employee.lastLogin) 
      }));
    }
  
    const data = employees?.result || [];
  
    return data.map((employee) => ({
      ...employee,
      empId: employee.empId || "N/A",
      fullName: `${employee.firstName} ${employee.lastName}`,
      status: employee.status ? "Active" : "Inactive",
      lastLogin: formatDate(employee.lastLogin)
    }));
  })();
  
  function formatDate(dateString) {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
  
  
  const columns = [
    { label: "EmpID", accessor: "empId" },
    { label: "Name", accessor: "fullName" },
    { label: "Designation", accessor: "designationName" },
    { label: "Reports To", accessor: "reportToName" },
    { label: "Status", accessor: "status" },
    { label: "Last Login", accessor: "lastLogin" },
  ];
  const handleEditEmployee = (row) => {
    history.push({
      pathname: '/admin/UpdateEmployees',
      employee: { row },
      id: row.id,
    });
  };
  const actions = [
    {
      label: 'Edit employee',
      icon: <EditOutlinedIcon />,
      permission: 'CanUpdateEmployee',
      handler: handleEditEmployee,
    },
  ];

  return (
    <div>
      <div className="main-container">
        <div className="content-header">
          <div className="header-navigation">
            <BodySmallMedium text="Manage" color="#A1A2A4" />
            <img src={chevron_rightIcon} alt="Chevron Right" className="chevron-right-icon" />
            <BodySmallMedium text="Employee" color="#1E293B" />
          </div>
        </div>
        <Heading6Regular text="Employee" color="#1E293B" />
        <div className="content-wrapper">
          <div className="employee-header-row mb-5">
            <div className="employee-header-left">
              <SearchInput
                placeholder="Search"
                onChange={(e) => handleSearchChange(e.target.value)}
                value={query}
              />
              <CustomFilterSelect
                label="Status"
                width="140px"
                value={statusFilter}
                onChange={handleStatusFilterChange}
                options={[
                  { id: 1, name: 'All' },
                  { id: 2, name: 'Active' },
                  { id: 3, name: 'Inactive' },
                ]}
              />
            </div>

            <div className="employee-header-right">
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalCount}
                itemsPerPage={itemsPerPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />
              <div style={{ paddingRight: '12px' }}>
                <IconButton onClick={handleEmployeeDownload}>
                  <Download />
                </IconButton>
              </div>
              {permissions.includes("CanAddEmployee") && (
                <CustomButton
                  text="Add Employee"
                  width="180px"
                  onClick={handleAddEmployeeClick}
                />
              )}
            </div>
          </div>
          <DynamicTable
            data={EmployeeData}
            isLoading={employees === "isLoading"}
            columns={columns}
            permissions={permissions}
            actions={actions}
            thIcon={thIcon}
          />
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            {totalCount > 0 && (
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalCount}
                itemsPerPage={10}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Employees;
